import { Inject, Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { LaravelDefaultResponse } from '../../../interfaces/responses';
import { ApiService } from '../../shared/services/api.service';
import { Oauth2Provider } from '../../../models/provider.model';

@Injectable({
  providedIn: 'root',
})
export class Oauth2Service {
  private _apiService = inject(ApiService);

  constructor(
    @Inject('OAUTH2_PROVIDERS_URL') private _oauth2ProvidersUrl: string
  ) { }

  // Removed fetchToken method - no longer needed with direct callback approach

  public getProviders(): Observable<Oauth2Provider[]> {
    return this._apiService
      .get<LaravelDefaultResponse<Oauth2Provider[]>>(this._oauth2ProvidersUrl, {}, { headers: this._apiService.validationOnlyHeader })
      .pipe(
        map((response: LaravelDefaultResponse<Oauth2Provider[]>) => {
          return response.data;
        })
      );
  }
}
